var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CardContainer',[_c('div',{staticClass:"bg-offWhite p-sm rounded-t-lg border-solid border-0 border-b-1 border-border text-black"},[_vm._t("header")],2),_c('div',{staticClass:"bg-whiteOverride rounded-b-lg"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }